import React, {Component} from 'react';
import PropTypes from "prop-types";

class SensorsContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;

    }

    render() {

        return (
            <div>
                <div className="ma-bo-20 clearfix">
                    <div className="clearfix">
                        <nav>
                            <h1>{this.translate('sensors')} ({this.translate('superadminOnly')})</h1>
                        </nav>
                    </div>

                    <div className="clearfix">
                        <p>Superadmin only (V3).</p>
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default SensorsContainer;